module.exports = __webpack_public_path__ + "img/round-arrow-black.b4e8cd28.svg";